module.exports = __webpack_public_path__ + "img/icon-logo-1.3271d1d3.png";